import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=1e4e4ea2&scoped=true&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"
import style0 from "./tag-input.vue?vue&type=style&index=0&id=1e4e4ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e4ea2",
  null
  
)

export default component.exports